var React = require('react');

function FileText (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z","key":0}),React.createElement("polyline",{"points":"14 2 14 8 20 8","key":1}),React.createElement("line",{"x1":"16","y1":"13","x2":"8","y2":"13","key":2}),React.createElement("line",{"x1":"16","y1":"17","x2":"8","y2":"17","key":3}),React.createElement("polyline",{"points":"10 9 9 9 8 9","key":4})]);
}

FileText.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-file-text"};

module.exports = FileText;

FileText.default = FileText;
